/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const scan_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.312 12H5.686M16.5 20.997h3.554a.946.946 0 0 0 .946-.946v-3.553M16.5 3h3.554a.946.946 0 0 1 .946.946V7.5M7.5 3H3.945A.946.946 0 0 0 3 3.946V7.5M7.5 21H3.945A.946.946 0 0 1 3 20.054V16.5"
    />
  </svg>
)
export default scan_medium
